// extracted by mini-css-extract-plugin
module.exports = {"CenteredText_container":"CenteredText_CenteredText_container__1rC2u","CenteredText":"CenteredText_CenteredText__4QTR3"};